export const notifyBuilder = (fn: ((data: Record<string, any>) => any) | null) => (data: Record<string, any>) => {
    if (fn) {
        return fn({ ...data, when: new Date(), target: "s3", resource: "fileUpload" });
    }

    return null;
};
